import type { SVGProps } from "react";
const SvgEye = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(-1008 -144)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1017.88 153.879C1018.44 153.316 1019.2 153 1020 153C1020.8 153 1021.56 153.316 1022.12 153.879C1022.68 154.441 1023 155.204 1023 156C1023 156.796 1022.68 157.559 1022.12 158.121C1021.56 158.684 1020.8 159 1020 159C1019.2 159 1018.44 158.684 1017.88 158.121C1017.32 157.559 1017 156.796 1017 156C1017 155.204 1017.32 154.441 1017.88 153.879ZM1020 155C1019.73 155 1019.48 155.105 1019.29 155.293C1019.11 155.48 1019 155.735 1019 156C1019 156.265 1019.11 156.52 1019.29 156.707C1019.48 156.895 1019.73 157 1020 157C1020.27 157 1020.52 156.895 1020.71 156.707C1020.89 156.52 1021 156.265 1021 156C1021 155.735 1020.89 155.48 1020.71 155.293C1020.52 155.105 1020.27 155 1020 155Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1012.18 156C1014.39 159.441 1017 161 1020 161C1023 161 1025.61 159.441 1027.82 156C1025.61 152.559 1023 151 1020 151C1017 151 1014.39 152.559 1012.18 156ZM1010.14 155.486C1012.66 151.286 1015.94 149 1020 149C1024.06 149 1027.34 151.286 1029.86 155.486C1030.05 155.802 1030.05 156.198 1029.86 156.514C1027.34 160.714 1024.06 163 1020 163C1015.94 163 1012.66 160.714 1010.14 156.514C1009.95 156.198 1009.95 155.802 1010.14 155.486Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default SvgEye;
